import { Modal, Box, Typography, InputBase, Button, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, Menu, MenuItem, IconButton, Checkbox, FormControlLabel, Select, FormControl, InputLabel } from "@mui/material" // Added Select, FormControl, InputLabel
import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { formStyle } from "./inventoryForm"
import CustomAxios from "../utils/CustomAxios"
import { updateCategoryForm, updateConfirmationPop, updateProductCategory, updateConfirmationMessage, updateConfirmationOperation, updateFormModal, updateSelectedCategory } from "../redux/products"
import { TranslateText } from "../utils/googletranslator"
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Confirmation from "./confirmation";
import { updateSnackBarMessage, updateSnackBarOpen, updateSnackBarSeverity } from "../redux/snackbar"

const AddCategory = () => {
    const open = useSelector(state => state.product.openCategory)
    const user = useSelector(state => state.user.id)
    const categories = useSelector(state => state.product.productCategory)
    const [category, setCategory] = useState({})
    const [anchorEl, setAnchorEl] = useState(null);
    const selectedcategory = useSelector(state => state.product.selectedCategory);
    const menuOpen = Boolean(anchorEl);
    const [error, setError] = useState({})

    const dispatch = useDispatch()

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        dispatch(updateSelectedCategory(item))
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // --- UPDATED VALIDATION LOGIC ---
    const validateForm = () => {
        let error = {}
        let valid = true
        if (!category.name?.trim()) {
            valid = false
            error.name = "please enter category name"
        }
        if (!category.title?.trim()) {
            valid = false
            error.title = "please enter Title"
        }
        if (!category.subTitle?.trim()) {
            valid = false
            error.subTitle = "please enter Sub title"
        }
        // New Type Validation
        if (!category.type) {
            valid = false
            error.type = "please select a type"
        }
        if (!category.grad_primary?.trim()) {
            valid = false
            error.grad_primary = "please enter color code"
        }
        if (!category.grad_secondary?.trim()) {
            valid = false
            error.grad_secondary = "please enter color code"
        }

        setError(error)
        return valid
    }

    const submitForm = () => {
        let formValidation = validateForm(category)
        if (!category.globalpublish){
            setCategory({...category, globalpublish : false})
        }
        if (!category.socialpublish){
            setCategory({...category, socialpublish: false})
        }
        if (formValidation) {
            if (Object.keys(selectedcategory).length <= 0) {
                CustomAxios.post("create_categories/", { category: category, user: user }).then(res => {
                    if (res.data.message == 'Successfully Created') {
                        dispatch(updateProductCategory(res.data.categories ? res.data.categories : []))
                        dispatch(updateCategoryForm(false))
                        setCategory({});
                        dispatch(updateSelectedCategory({}));
                        setError({})
                        dispatch(updateSnackBarMessage("Category Successfully created"))
                        dispatch(updateSnackBarSeverity("success"))
                        dispatch(updateSnackBarOpen(true))
                    }
                })
            }
            else {
                CustomAxios.put("create_categories/", { ...selectedcategory, category: category }).then(res => {
                    if (res.data.message == 'Successfully Created') {
                        dispatch(updateProductCategory(res.data.categories ? res.data.categories : []))
                        setCategory({});
                        dispatch(updateSelectedCategory({}));
                        setError({})
                        dispatch(updateSnackBarMessage("Category Successfully updated"))
                        dispatch(updateSnackBarSeverity("success"))
                        dispatch(updateSnackBarOpen(true))
                    }
                })
            }
        }
    }

    useEffect(() => {
        CustomAxios.get('create_categories/').then(res => {
            if (res.data.message == 'Successfully Fetched') {
                dispatch(updateProductCategory(res.data.categories ? res.data.categories : []))
            }
        }).catch(err => console.log(err))
    }, [])

    let editCategory = (item, e) => {
        e.preventDefault()
        setCategory(selectedcategory)
        handleClose()
    }
    const deleteCategory = () => {
        dispatch(updateFormModal("category"))
        dispatch(updateSelectedCategory(selectedcategory))
        dispatch(updateConfirmationPop(true))
        dispatch(updateConfirmationMessage("Are you sure, Do you want to Delete?"))
        dispatch(updateConfirmationOperation("confirmation"))
        handleClose()
    }

    const deleteCatAction = () => {
        CustomAxios.delete(`create_categories/${selectedcategory.id}`).then(res => {
            if (res.data.message == 'Successfully deleted') {
                dispatch(updateProductCategory(res.data.categories ? res.data.categories : []))
                dispatch(updateCategoryForm(false))
                dispatch(updateConfirmationPop(false))
                handleClose()
            }
            else {
                dispatch(updateConfirmationPop(true))
                dispatch(updateConfirmationOperation("error"))
                dispatch(updateConfirmationMessage("Sorry, Please update category on previous products"))
            }
        }).catch(err => {
            dispatch(updateConfirmationPop(true))
            dispatch(updateConfirmationOperation("error"))
            dispatch(updateConfirmationMessage("Sorry, Please update category on previous products"))
        })
    }

    return <>
        <Modal
            open={open}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
            sx={{ zIndex: "21 !important" }}
        >
            <Box sx={{ width: "600px", background: "#fff", left: "50%", top: "50%", position: "absolute", transform: 'translate(-50%, -50%)', padding: "24px", border: "none", overflowY: "auto", height: { xs: "95%", sm: "max-content" } }}>

                <Typography sx={{ paddingBottom: "15px" }}>Add Category</Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }} >
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "5px", }}>
                        <Box sx={{ display: "flex", gap: "5px", flexDirection: "column" }}>
                            <Box>
                                <TranslateText>Name</TranslateText>
                                <InputBase value={category.name||""} sx={formStyle.inputBase} onChange={(e) => setCategory({ ...category, name: e.target.value })} />
                                <TranslateText sx={{ color: "error.light" }}>{error.name} </TranslateText>
                            </Box>
                            <Box>
                                <TranslateText>Title</TranslateText>
                                <InputBase value={category.title||""} sx={formStyle.inputBase} onChange={(e) => setCategory({ ...category, title: e.target.value })} />
                                <TranslateText sx={{ color: "error.light" }}>{error.title} </TranslateText>
                            </Box>
                            <Box>
                                <TranslateText>Sub Title</TranslateText>
                                <InputBase value={category.subTitle||""} sx={formStyle.inputBase} onChange={(e) => setCategory({ ...category, subTitle: e.target.value })} />
                                <TranslateText sx={{ color: "error.light" }}>{error.subTitle} </TranslateText>
                            </Box>

                            <Box>
                                <TranslateText>Type <span style={{ color: "red" }}>*</span></TranslateText>
                                <FormControl fullWidth sx={{ marginTop: "5px" }}>
                                    <Select
                                        value={category.type || ""}
                                        onChange={(e) => setCategory({ ...category, type: e.target.value })}
                                        displayEmpty
                                        sx={{
                                            width: "100%",
                                            border: "1px solid",
                                            borderColor: "grey.400",
                                            borderRadius: "5px",
                                            height: "48px",
                                            fontSize: "16px",
                                            padding: "0 14px",
                                            color: "grey.700",
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                        }}
                                    >
                                        <MenuItem value="" disabled>Select Type</MenuItem>
                                        <MenuItem value="subscription">Subscription</MenuItem>
                                        <MenuItem value="product">Product</MenuItem>
                                    </Select>
                                </FormControl>
                                <TranslateText sx={{ color: "error.light" }}>{error.type}</TranslateText>
                            </Box>

                            <Box sx={{ display: "flex", gap: "5px" }}>
                                <Box>
                                    <TranslateText>Gradient 1</TranslateText>
                                    <InputBase value={category.grad_primary||""} sx={formStyle.inputBase} onChange={(e) => setCategory({ ...category, grad_primary: e.target.value })} />
                                    <TranslateText sx={{ color: "error.light" }}>{error.grad_primary} </TranslateText>
                                </Box>
                                <Box>
                                    <TranslateText>Gradient 2</TranslateText>
                                    <InputBase value={category.grad_secondary||""} sx={formStyle.inputBase} onChange={(e) => setCategory({ ...category, grad_secondary: e.target.value })} />
                                    <TranslateText sx={{ color: "error.light" }}>{error.grad_secondary} </TranslateText>
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex", gap: "5px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={category.globalpublish || false}
                                            onChange={(e) => setCategory({ ...category, globalpublish: e.target.checked })}
                                        />
                                    }
                                    label={<TranslateText>Global plan</TranslateText>}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={category.socialpublish || false}
                                            onChange={(e) => setCategory({ ...category, socialpublish: e.target.checked })}
                                        />
                                    }
                                    label={<TranslateText>Social plan</TranslateText>}
                                />
                            </Box>

                        </Box>


                        <Box sx={{ alignSelf: "end", display: "flex", gap: "5px" }}>
                            <Button variant="contained" sx={{ maxWidth: "100px", alignSelf: "end", textTransform: "none", height: "48px" }} onClick={() => submitForm()}>{Object.keys(selectedcategory).length > 0 && Object.keys(category).length > 0 ? "Save" : "Add"}</Button>
                            <Button variant="outlined" sx={{ maxWidth: "100px", alignSelf: "end", textTransform: "none", height: "48px" }} onClick={() => { dispatch(updateCategoryForm(false)); setCategory(""); dispatch(updateSelectedCategory({})); setError("") }}>Cancel</Button>

                        </Box>

                    </Box>

                    <TableContainer>
                        <Table>
                            <TableHead sx={{ bgcolor: "#E2E8F0" }}>
                                <TableRow>
                                    <TableCell sx={{ textAlign: "left" }}><TranslateText>No.</TranslateText> </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}><TranslateText>Name</TranslateText> </TableCell>
                                    <TableCell sx={{ textAlign: "left" }}><TranslateText>Actions</TranslateText> </TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {categories?.map(item => <TableRow key={item.id}>
                                    <TableCell sx={{ textAlign: "left" }}>{item.id}</TableCell>
                                    <TableCell sx={{ textAlign: "left" }}>{item.name}</TableCell>
                                    <TableCell sx={{ textAlign: "left" }}> <IconButton
                                        aria-label="actions"
                                        aria-controls={`actions-menu-${item.id}`}
                                        aria-haspopup="true"
                                        onClick={(e) => handleClick(e, item)}
                                    >
                                        <MoreHorizIcon />
                                    </IconButton>
                                        <Menu
                                            id={`actions-menu-${selectedcategory?.id}`}
                                            MenuListProps={{
                                                'aria-labelledby': 'data-array-button',
                                            }}
                                            anchorEl={anchorEl}
                                            open={menuOpen && selectedcategory?.id == item.id}
                                            onClose={handleClose}
                                        >

                                            <MenuItem onClick={(e) => editCategory(item.id, e)}>
                                                Edit
                                            </MenuItem>
                                            <MenuItem onClick={(e) => deleteCategory(item.id, e)}>
                                                Delete
                                            </MenuItem>

                                        </Menu>
                                    </TableCell>
                                </TableRow>)}


                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>

        </Modal>
    </>
}

export default AddCategory